import { render, staticRenderFns } from "./DeleteTeamFromStageTournament.vue?vue&type=template&id=4d465f5d&scoped=true"
import script from "./DeleteTeamFromStageTournament.vue?vue&type=script&lang=js"
export * from "./DeleteTeamFromStageTournament.vue?vue&type=script&lang=js"
import style0 from "./DeleteTeamFromStageTournament.vue?vue&type=style&index=0&id=4d465f5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d465f5d",
  null
  
)

export default component.exports